var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListingBeds = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 52 38"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.713 14.694 2.5 21.234M43 14.5h5M9 14.5H4M51.5 23.5H.5v-2h51zM1.5 24v13.5h3v-4h44v4h2V24M48.5 14V3M3.5 3v11M5.5 3v11M46.5 3v11M49.5 2.5h-47v-2h47zM42.516 15.33c.065.597-.403 1.168-1.047 1.254-4.55.51-9.182.51-13.73 0-.645-.084-1.113-.657-1.048-1.253l.788-7.501c.065-.598.57-1.247 1.13-1.425 3.977-1.274 8.012-1.274 11.99 0 .56.18 1.065.828 1.13 1.425zM25.309 15.33c.065.597-.403 1.168-1.047 1.254-4.55.51-9.181.51-13.731 0-.643-.084-1.112-.657-1.047-1.253l.788-7.501c.065-.598.57-1.247 1.13-1.425 3.977-1.274 8.012-1.274 11.989 0 .56.177 1.066.828 1.13 1.425zM48.287 14.694l1.213 6.54"
}))));
export default SvgListingBeds;